export const SUBMIT_PHRASE_FORM = 'phraseForm/SUBMIT_PHRASE_FORM';
export const CHAPTER_CHECKBOX_CLICK = 'cpsrPhraseForm/CHAPTER_CHECKBOX_CLICK';
